export const extrajudicialNotificationStatus = [
  'IN_PROGRESS',
  'POSITIVE',
  'NEGATIVE',
];

export type ExtrajudicialNotificationStatus =
  (typeof extrajudicialNotificationStatus)[number];
